import React from "react";
import { Link as RouterLink } from "react-router-dom";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Whatsapp from "@iconscout/react-unicons/icons/uil-whatsapp";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";
import { CLOUD_URL } from "../../seo/seoConfig";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <nav className="f-links" aria-label="روابط التذييل">
          <RouterLink to="/">الرئيسية</RouterLink>
          <RouterLink to="/erp">حلول ERP</RouterLink>
          <a href={CLOUD_URL} target="_blank" rel="noopener noreferrer">
            النظام السحابي
          </a>
        </nav>
        <span>© جميع الحقوق محفوظة 2026. لايت سوفت</span>
        <div className="f-icons">
          <a href="https://www.facebook.com/profile.php?id=100063958034097">
            <Facebook color="white" size={"3rem"} />
          </a>

          <a
            href="https://wa.me/967777926572"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="واتساب"
          >
            <Whatsapp color="white" size={"3rem"} />
          </a>
          <Gitub color="white" size={"3rem"} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
